import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth.js"
import lang from "./modules/lang.js"
import roles from "./modules/roles.js"
import WebsiteSetting from "./modules/WebsiteSetting.js"

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        lang,
        roles,
        WebsiteSetting,
    }
});
